"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComparisonOperator = exports.LogicalOperator = void 0;
// Not db models, only used for parsing the rules column. Should be moved?
var LogicalOperator;
(function (LogicalOperator) {
    LogicalOperator["AND"] = "AND";
    LogicalOperator["OR"] = "OR";
})(LogicalOperator = exports.LogicalOperator || (exports.LogicalOperator = {}));
var ComparisonOperator;
(function (ComparisonOperator) {
    ComparisonOperator["EQ"] = "EQ";
    ComparisonOperator["GT"] = "GT";
    ComparisonOperator["GTE"] = "GTE";
    ComparisonOperator["LT"] = "LT";
    ComparisonOperator["LTE"] = "LTE";
})(ComparisonOperator = exports.ComparisonOperator || (exports.ComparisonOperator = {}));
